import { useCatalogItems } from "@api/catalogItem.api";
import { NativeInvoiceLineRow } from "@components/invoices/NativeInvoiceDrawer/nativeInvoiceFormTypes";
import {
    acceptedCatalogItemPatch,
    suggestedCatalogItem,
} from "./catalogItemSuggestion";

export function useCatalogItemSuggestions({
    entityId,
    lines,
    updateLine,
}: {
    entityId: number | undefined;
    lines: NativeInvoiceLineRow[];
    updateLine: (lineId: string, patch: Partial<NativeInvoiceLineRow>) => void;
}) {
    const { items } = useCatalogItems({
        entityIds: entityId === undefined ? undefined : [entityId],
        enabled: entityId !== undefined,
    });
    const entityItems = items.filter((item) => item.entityId === entityId);
    const suggestions = lines.flatMap((line) => {
        const item = suggestedCatalogItem({ items: entityItems, line });
        return item ? [{ line, item }] : [];
    });

    const confirmItemSuggestions = (lineIds: readonly string[]) => {
        suggestions
            .filter(({ line }) => lineIds.includes(line.id))
            .forEach(({ line, item }) =>
                updateLine(line.id, acceptedCatalogItemPatch({ line, item })),
            );
    };

    return {
        suggestedItemLineIds: suggestions.map(({ line }) => line.id),
        confirmItemSuggestions,
        tasks:
            suggestions.length > 0
                ? [
                      {
                          id: "suggested-item",
                          message: "Confirm the suggested item",
                      },
                  ]
                : [],
    };
}
